import api from "./api";

class AttivitaManager {

    attivitaList(config?: any) {
        return api.get(`/attivita_crm/`, config)
    }

    attivita(attivita_id: number | string | undefined, config?: any) {
        return api.get(`/attivita_crm/${attivita_id}`, config)
    }

    retrieve = this.attivita
    list = this.attivitaList
}

const attivitaManager = new AttivitaManager()

export default attivitaManager
